var _style, _g, _g2, _g3, _polygon, _polyline, _polyline2, _rect, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInspectionSet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#023047;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:#FB8500;stroke:#023047;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000046313336999963125300000004703677654534772920_"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "23.9,26 23.9,35.8 8.2,35.8 8.2,14.6 11.6,14.6  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000143609400578232523040000010278134986020032411_"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "16.2,8 16.2,5.6 19.6,5.6 31.9,5.6 31.9,17 31.9,26.8 29.8,26.8  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000062155104022288283920000015814559365182106270_"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "12.1,12.1 12.1,9.9 15.4,9.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "27.8,21.3 27.8,31.1 25.5,31.1  "
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "21,11.4 22.6,12.9 24.7,12.6 25.1,14.7 26.9,15.7 26,17.5 26.9,19.5 25.1,20.4 24.7,22.5 22.6,22.2  21,23.7 19.6,22.2 17.5,22.5 17.1,20.4 15.2,19.5 16.1,17.5 15.2,15.7 17.1,14.7 17.5,12.6 19.6,12.9 "
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "18.9,17.8 20.6,19.3 23.2,16.7 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "15.1,22.9 11,22.9 11,17.1 13.2,17.1 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 26.4,
    className: "st0",
    width: 5.9,
    height: 5.9
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 18.9,
    y1: 29.3,
    x2: 21.6,
    y2: 29.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 20.2,
    y1: 8.2,
    x2: 27.8,
    y2: 8.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspectionSet);
export default __webpack_public_path__ + "static/media/inspectionSet.a80b00db9fb278c190707cf029fde55c.svg";
export { ForwardRef as ReactComponent };